export default __webpack_public_path__ + "static/media/vas-provider-junction.dc835b27.yaml";